import React from 'react';
import { resetAnalytics } from 'providers/analytics';

const SessionLost = () => {
  React.useEffect(() => {
    resetAnalytics();
    sessionStorage.clear();
    window.location.href = '/';
  }, []);

  return null;
};

export default SessionLost;
